export default "__VITE_ASSET__B09Gdbn9__"